import React from "react";
import Button from "../../../common/button/button.js";
import Text from "../../../common/typography/text.js";
import Panel from "../../../common/panel/index.js";
import "./../AABI.css";

// Shared by every AABI fetch site (§5.7). Never redirects — just offers a
// Retry that re-issues the same fetch (§4.5).
const AABIErrorPanel = ({
  message = "Something went wrong loading this data.",
  onRetry,
}) => (
  <Panel contentClassName="aabi-error-panel" role="alert">
    <Text variant="bodyText" color="failureColor">
      {message}
    </Text>
    {onRetry && (
      <Button variant="primary" onClick={onRetry}>
        Retry
      </Button>
    )}
  </Panel>
);

export default AABIErrorPanel;
